import { doc, getDoc } from 'firebase/firestore';

// Reads users/{uid}.role and returns where that user belongs.
// Admin is excluded from the customer-facing platform flow (iOS parity).
export async function routeForRole(db, uid) {
  try {
    const snap = await getDoc(doc(db, 'users', uid));
    const role = snap.data()?.role;
    if (role === 'restaurant') return '/business';
    if (role === 'driver') return '/driver';
    return '/';
  } catch (e) {
    console.warn('routeForRole failed:', e);
    return '/';
  }
}
